import dialogTable from "@/CommonDP/pages/commonRender/components/dialogTable";
import Vue from "vue";
export const isVue = (component) => {
  return component instanceof Vue;
};
export default async function openDynTableDlg(that, ...params) {
  return await addComponent(that, dialogTable, ...params);
}
function addComponent(that, component, ...params) {
  console.log(component);
  const Comp = Vue.extend(component);
  const store = require("@/CommonDP/store/index.js").default;
  let instance;
  const pro = new Promise((resolve, reject) => {
    try {
      if (isVue(that)) {
        instance = (that.$root.$children || []).find((comp) => {
          return comp.$options.name === component.name;
        });
        if (!instance) {
          instance = new Comp({
            store
          });
          that.$root.$children.push(instance);
          instance.$parent = that;
          instance.$mount();
          instance.$on("closeDlg", () => {
            resolve();
          });
        }
      } else {
        instance = new Comp({
          store
        });
        instance.$mount();
        document.body.appendChild(instance.$el);
        instance.$on("closeDlg", () => {
          document.body.removeChild(instance.$el);
          resolve();
        });
      }
      instance.openDlg(...params);
    } catch (error) {
      console.error(error);
      reject();
    }
  });
  return pro;
}
